var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderbookExtender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Free_transform",
    "data-name": "Free transform"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62,9a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H56a1,1,0,0,0-1,1V4H36V2a1,1,0,0,0-1-1H29a1,1,0,0,0-1,1V4H9V2A1,1,0,0,0,8,1H2A1,1,0,0,0,1,2V8A1,1,0,0,0,2,9H4V28H2a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H4V55H2a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H8a1,1,0,0,0,1-1V60H28v2a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V60H55v2a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V56a1,1,0,0,0-1-1H60V36h2a1,1,0,0,0,1-1V29a1,1,0,0,0-1-1H60V9ZM57,3h4V7H57ZM30,3h4V7H30ZM3,7V3H7V7ZM3,34V30H7v4ZM7,61H3V57H7Zm27,0H30V57h4Zm27-4v4H57V57Zm0-27v4H57V30Zm-3-2H56a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h2V55H56a1,1,0,0,0-1,1v2H36V56a1,1,0,0,0-1-1H29a1,1,0,0,0-1,1v2H9V56a1,1,0,0,0-1-1H6V36H8a1,1,0,0,0,1-1V29a1,1,0,0,0-1-1H6V9H8A1,1,0,0,0,9,8V6H28V8a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V6H55V8a1,1,0,0,0,1,1h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,47H29a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,16V26a1,1,0,0,1-2,0V18.41L18.41,47H26a1,1,0,0,1,0,2H16a1,1,0,0,1-.38-.08.956.956,0,0,1-.54-.54A1,1,0,0,1,15,48V38a1,1,0,0,1,2,0v7.59L45.59,17H38a1,1,0,0,1,0-2H48a1,1,0,0,1,.38.08.956.956,0,0,1,.54.54A1,1,0,0,1,49,16Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderbookExtender);
export default __webpack_public_path__ + "static/media/orderbook_extender.b045c8701ea11b0459fc4a71a9ec476b.svg";
export { ForwardRef as ReactComponent };